module.exports = __webpack_public_path__ + "img/A58A2363.54298704.jpg";